import {Component, ChangeDetectionStrategy} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SummaryInfoComponent} from '@components/summary-info/summary-info.component';

import {TranslatePipe} from '@ngx-translate/core';
import {ThemeModule} from '@app/themes/theme-module';
import {IMenuItem} from '@models/i-menu-item';
import {SummaryParent} from '@app/wrappers/summary-parent';
import {MenuChildrenPipe} from '@app/utils/pipes/menu-children.pipe';

@Component({
  selector: 'app-prime-page',
  standalone: true,
  imports: [CommonModule, SummaryInfoComponent, ThemeModule, TranslatePipe, MenuChildrenPipe],
  templateUrl: './crop-monitoring-summary.html',
  styleUrl: './crop-monitoring-summary.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CropMonitoringSummaryComponent extends SummaryParent{

  items: IMenuItem[] = [
    {
      icon: 'assets/icons/main/light/ico-document.svg',
      iconBack: 'assets/icons/main/light/examination-request-back.svg',
      title: 'Examination requests',
      url: '/crop-monitoring/requests',
      cardStyle: { background: '#BDC8F2' }
    },
    {
      icon: 'assets/icons/main/light/icon-chart.svg',
      iconBack: 'assets/icons/main/light/ico-table-of-contents-reports-back.svg',
      title: 'Survey templates',
      url: '/crop-monitoring/mobile-templates',
      iconClass: 'table-of-contents-reports',
      cardStyle: { background: '#CCCFDA' }
    },
    {
      icon: 'assets/icons/main/light/icon-gis-fields.svg',
      iconBack: 'assets/icons/main/light/icon-gis-fields-back.svg',
      title: 'GIS',
      url: '/crop-monitoring/gis',
      cardStyle: { background: '#0088E94D' }
    },
    {
      icon: 'assets/icons/main/light/ico-satellite-summary.svg',
      iconBack: 'assets/icons/main/light/icon-satellite-images-back.svg',
      title: 'Satellite Images',
      url: '/crop-monitoring/satellite-images',
      cardStyle: { background: '#8BAAFF' }
    },
  ];
}
